import { render, staticRenderFns } from "./delayedMsg.vue?vue&type=template&id=777d066a"
import script from "./delayedMsg.vue?vue&type=script&lang=js"
export * from "./delayedMsg.vue?vue&type=script&lang=js"
import style0 from "./delayedMsg.vue?vue&type=style&index=0&id=777d066a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports